// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__2Wu98","title":"styles_title__1zbxy","state":"styles_state__3aSgD","table":"styles_table__3TtwJ"};